export default __webpack_public_path__ + "static/media/piggyBG.10e1dc40.svg";